import type { Ref } from 'vue';

import { useQuery } from '@tanstack/vue-query';

import type { Inverters } from '~/types/equipment';

import { useCrudCreate, useCrudUpdate } from '~/shared/hooks/useCrudMutations';
import useCrudQuery from '~/shared/hooks/useCrudQuery';
import { resolveEquipmentConflictMessage } from '~/utils/equipmentErrors';

import invertersService from '../services/invertersService';

export function useCreateInverter() {
  const handleError = (error: any) => {
    const conflictMessage = resolveEquipmentConflictMessage(error);
    if (conflictMessage) return conflictMessage;
    return error?.response?.data?.message || 'Erro ao cadastrar inversor';
  };

  return useCrudCreate(
    'inverters',
    'Inversor',
    invertersService.create.bind(invertersService),
    handleError,
  );
}

export function useInverterById(id: Ref<null | number>) {
  return useQuery({
    enabled: () => !!id.value,
    queryFn: () => {
      if (!id.value) throw new Error('ID é obrigatório');
      return invertersService.getById(id.value);
    },
    queryKey: ['inverter', id],
  });
}

export function useInverters(params: Ref<Inverters.GetInvertersRequest>) {
  return useCrudQuery(params, 'inverters', invertersService.list.bind(invertersService));
}

export function useUpdateInverter() {
  const handleError = (error: any) => {
    if (error?.response?.status === 404) {
      return 'Inversor não encontrado';
    }
    const conflictMessage = resolveEquipmentConflictMessage(error);
    if (conflictMessage) return conflictMessage;
    return error?.response?.data?.message || 'Erro ao atualizar inversor';
  };

  return useCrudUpdate(
    'inverters',
    'Inversor',
    invertersService.update.bind(invertersService),
    handleError,
  );
}
